export const PropertySearchForm = [
  {
    operationType: 'COMPRA',
    propertyType: 'Casa de Condomínio',
    details:
      'Procuro casa com 4 suítes, piscina térmica e área gourmet coberta',
    desiredCity: 'Campinas',
    clientInfo: {
      name: 'Gabriela Fernandes',
      email: 'gabriela.f@imobiliaria.com.br',
      phone: '(19) 99876-5432',
      neighborhood: 'Barão Geraldo'
    }
  },
  {
    operationType: 'ALUGUEL',
    propertyType: 'Apartamento Corporativo',
    details:
      'Necessário apartamento mobiliado próximo a centros empresariais, mínimo 2 vagas',
    desiredCity: 'São Paulo',
    clientInfo: {
      name: 'Ricardo Almeida',
      email: 'ricardo.executivo@email.com',
      phone: '(11) 91234-5678',
      neighborhood: 'Brooklin'
    }
  },
  {
    operationType: 'TEMPORADA',
    propertyType: 'Casa de Praia',
    details:
      'Busco casa para temporada de verão com acesso direto à praia e capacidade para 10 pessoas',
    desiredCity: 'Maceió',
    clientInfo: {
      name: 'Carolina Moura',
      email: 'carol.moura@viagens.com',
      neighborhood: 'Ponta Verde'
    }
  },
  {
    operationType: 'COMPRA',
    propertyType: 'Sítio Urbano',
    details:
      'Interessado em sítio de até 5 hectares com nascente e infraestrutura básica',
    desiredCity: 'Brasília',
    clientInfo: {
      name: 'Marcos Ribeiro',
      email: 'marcos.agronegocio@email.com',
      phone: '(61) 98765-1234'
    }
  },
  {
    operationType: 'ALUGUEL',
    propertyType: 'Galpão Logístico',
    details:
      'Necessito de galpão com 2.000m², pé direito alto e acesso para caminhões',
    desiredCity: 'Guarulhos',
    clientInfo: {
      name: 'Logística Express Ltda',
      email: 'compras@logexpress.com.br',
      phone: '(11) 4004-2233'
    }
  },
  {
    operationType: 'TEMPORADA',
    propertyType: 'Chalé Montanhoso',
    details: 'Busco chalé aconchegante com lareira e vista para montanhas',
    desiredCity: 'Gramado',
    clientInfo: {
      name: 'Felipe Costa',
      email: 'felipe.ecoturismo@email.com',
      neighborhood: 'Centro'
    }
  },
  {
    operationType: 'COMPRA',
    propertyType: 'Cobertura Duplex',
    details:
      'Procuro cobertura com lazer completo e vista panorâmica da cidade',
    desiredCity: 'Belo Horizonte',
    clientInfo: {
      name: 'Patrícia Lima',
      email: 'patricia.luxo@email.com',
      phone: '(31) 98888-1234'
    }
  },
  {
    operationType: 'ALUGUEL',
    propertyType: 'Studio Acadêmico',
    details: 'Preciso de studio mobiliado próximo à universidade',
    desiredCity: 'São Carlos',
    clientInfo: {
      name: 'Lucas Oliveira',
      email: 'lucas.engenharia@email.com',
      neighborhood: 'Centro'
    }
  },
  {
    operationType: 'TEMPORADA',
    propertyType: 'Fazenda Histórica',
    details:
      'Interessado em fazenda para eventos com estrutura colonial preservada',
    desiredCity: 'Ouro Preto',
    clientInfo: {
      name: 'Eventos Culturais MG',
      email: 'contato@culturamg.com.br',
      phone: '(31) 3333-4444'
    }
  },
  {
    operationType: 'COMPRA',
    propertyType: 'Loja Comercial',
    details: 'Procuro ponto comercial em área de alto fluxo para franquia',
    desiredCity: 'Curitiba',
    clientInfo: {
      name: 'Ana Beatriz Santos',
      email: 'anab.franquias@email.com',
      phone: '(41) 98765-0000',
      neighborhood: 'Batel'
    }
  }
];
